export default "__VITE_ASSET__uIikMkz4__"